import { BUTTON_PRESS } from '@/utils/analytics'

/**
 * Mixpanel event names for the Account audio settings. Shared by the legacy
 * `AudioSetting`, the rebrand `AudioSection`, and the `useIncidentAudio` toggle
 * so the names stay identical across the legacy and rebrand paths — renaming an
 * event breaks every saved Mixpanel report built on it.
 */
export const AUDIO_SETTINGS_ANALYTICS = {
  testAlert: `${BUTTON_PRESS} Settings - Audio Settings - Test Alert`,
  toggleAlerts: `${BUTTON_PRESS} Settings - Audio Settings - Toggle Alerts`,
} as const

/**
 * Mixpanel event names for the Account display settings. Shared by the legacy
 * `DarkModeSetting` and the rebrand `DarkModeSection` via `useDarkModeToggle`
 * so both paths emit the identical event (ENG-33713).
 */
export const DISPLAY_SETTINGS_ANALYTICS = {
  toggleDarkMode: `${BUTTON_PRESS} Settings - Display Settings - Toggle Dark Mode`,
} as const
